import { Component, OnInit, ViewChild, ViewContainerRef, Injector } from '@angular/core';
import { BaseService } from '../../../base/shared/services/base.service';
import { AlertsService } from '../../../base/services/alerts.service';
import { LoaderService } from '../../../base/services/loader.service';
import { SmartModalService } from '../../../base/services/smart-modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormComponent } from 'src/modules/base/components/form/form.component';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { AppService } from '../../shared/services/app.service';
import { PrintService } from '../../shared/services/print.service';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-popup-form',
    templateUrl: './popupform.component.html',
    styleUrls: ['./popupform.component.scss'],
    standalone: false
})
export class PopupFormComponent implements OnInit {
  @ViewChild('formComponenet') formComponenet: FormComponent;
  _currentAction: string;
  public _currentData: any = {};
  public _layout_data: Array<any> = [];
  _layout: any;
  @ViewChild('tabHorizontalComponent', { read: ViewContainerRef }) tabHorizontalComponent: ViewContainerRef;
  componentRef: any;
  newDataList: any;
  args: any = "";
  resourceDef: any = {};
  selected_page_size: any = 10;
  bulkaction: any = false;
  filterFields: any = {};
  filterVal: any;
  filter: any = "";

  constructor(
    public baseService: BaseService,
    private alerts: AlertsService,
    public loader: LoaderService,
    private smartModalService: SmartModalService,
    public injector: Injector,
    private route: ActivatedRoute,
    public dialogConfig: DialogConfig,
    public dialogRef: DialogRef,
    public rolePermissionService: RolePermissionService,
    public router?: Router,
    public appService?: AppService,
    public printService?: PrintService,
    public utilService?: UtilService
  ) { }

  ngOnInit() {
    console.log(this['data'], 'data');
    if (this['data'] == undefined) {
      if (this.dialogConfig != undefined) {
        this['data'] = this.dialogConfig;
      }
    }
    console.log("Action ", this['action']);
    if (this['action'] != undefined) {
      if (this['action'].popup != undefined && this['action'].popup.existing)
        this._currentData.existingData = this['data'];
      this['data'].data = this['data'];
      if (this['action'].popupDetails && this['action'].popupDetails.setDataResource) {
        this.getFormData(this['action'].popupDetails.setDataResource, this['data'].data);
      }
      this['data'] = this['action'].popupDetails;
    }

    this._currentData.configList = this['data']['config'] != undefined && this['data']['config'] ? this['data']['config'] : {
      "viewAll": true,
      "hideSearchBox": false,
      "hideResult": false,
      "allowPagination": true,
    }
    this._currentData.dataSet = false;
    this._currentData._currentFormFields = {};
    this._currentData._currentFormFields.loaded = false;
    this._currentData.render_template = true;
    this._currentData.qrCodeData = this['data']['qrCodeData'] ? this['data']['qrCodeData'] : {};
    this._currentData.resourceDef = this['data'];
    this._layout = this._currentData.resourceDef.layout_type;
    if (this['action'] == undefined) {
      if (this['data'].data) {
        this._currentData.currentData = this['data'].data;
        this._currentData.dataSet = true;
      } else {
        this._currentData.currentData = this['data'];
        this._currentData.dataSet = true;
      }
    }
    if (this['data'].type != undefined && this['data'].type == 'pullable') {
      this.bulkaction = {
        "key": "id",
        "button": [{
          "action": "copy",
          "label": "Submit"
        }]
      }
    }
    if (this._layout != 'simple') {
      this._currentData._layout_id = this._currentData.resourceDef.default_layout_id;
    }
    if (this['data'].action == "LIST") {
      this.loader.showSpinner();
      if (this['data'].preDefinedFields) {
        console.log("inside popup form resourcedef --elseIf--");
        this.getFields(this['data'].preDefinedFields)
      } else if (this['data'].resource) {
        console.log("resource  popup form resourcedef", this['data'].resource)
        this.baseService.getResourceDef(this['data'].resource, (resourceDef) => {
          console.log("inside popup form resourcedef", resourceDef);
          this.getFields(resourceDef)
        })
      } else {
        console.log("inside popup form resourcedef --else--");
        this.resourceDef.list = {};
        this.filterFields = null;
        this.resourceDef.list.fields = this['data']['fields'];
        if(this._currentData && this._currentData.resourceDef && this._currentData.resourceDef.btn && this._currentData.resourceDef.btn.length > 0){
          this.resourceDef.list.fields.push({"heading":"field.label.","name":"","order":18,"sortable":false,"config":{"type":"button","buttonMenu":[{"action":"delete","permission_required":false,"show_actions":true,"icon":"fa fa-trash"}]}})
        }
        this.newDataList = this['data']['data'];
        this._currentData.configList = this['data']['config'] == undefined ? this._currentData.configList : this['data']['config'];
        this.loader.hideSpinner();
      }
      if (this['data']['banner']) {
        this._currentData.bannerJson = this['data']['banner'];
      }
      this._currentAction = 'LIST';
    } else if (this['data'].action == "MODIFY") {
      this._currentAction = 'MODIFY';
      this.initLayoutData();
    } else {
      this._currentAction = 'ADD';
      this.initLayoutData();
    }

  }

  onBulkActionClicked(data){
    if(data){
       this.dialogRef.close(data);
    }
  }

  checkboxaction(data){
    if(data){
       this.dialogRef.close(data);
    }
  }

  getFields(resourceDef) {
    let params = {};
    console.log(resourceDef, 'resourceDef')
    this.resourceDef = resourceDef
    if (resourceDef.list != undefined && resourceDef.list.filter != undefined)
      this.filterFields['blocks'] = resourceDef;
    else
      this.filterFields = null;
    if (resourceDef.list != undefined && resourceDef.list.complex_search != undefined) {
      this._currentData.configList = {
        ...this._currentData.configList,
        complex_search: resourceDef.list.complex_search
      };
    };
    if (resourceDef.list && resourceDef.list.gridButtons != undefined) {
      if (resourceDef.list.fields.find(elem => (elem.name == 'gridButton')) == undefined) {
        resourceDef.list.gridButtons.name = "gridButton";
        resourceDef.list.fields.push(resourceDef.list.gridButtons);
      }
    }else if (this['data'].capability){
     let cap = {heading:'', name:'', order: resourceDef.list.fields.length +1, sortable: false, config:{showSettings: false,type:this['data'].capability.type,buttonMenu:this['data'].capability.data}}
     resourceDef.list.fields.push(cap);
    } else if (resourceDef && resourceDef.capability != undefined) {
      resourceDef.list.fields = this.rolePermissionService.getAllowedContextMenu(resourceDef.list.fields, resourceDef.capability, resourceDef.resource);
    }
    if(this['data']?.preDefinedFields?.list?.bulkAction){
         this.bulkaction = this['data'].preDefinedFields.list.bulkAction
    }
    else if (resourceDef?.list?.bulkAction) {
      this.bulkaction = resourceDef.list.bulkAction;
    }
    if(this['data'].datasource){
      let args;let filter;
      this.resourceDef.resource = this['data'].datasource.resource;
      this.resourceDef.application = this['data'].datasource.application;
      this.resourceDef.query_id = this['data'].datasource.queryId?this['data'].datasource.queryId:this['data'].datasource.query_id;
      if(this['data'].banner && this['data'].banner.key){
        if(this['data'].datasource.args){
          args = this.baseService.buildDyanamicStr(this['data'].datasource.args, { data: this['data'].banner.key });
          this.args = args;
        }
        if(this['data'].datasource.filter){
          filter = this.baseService.buildDyanamicStr(this['data'].datasource.filter, { data: this['data'].banner.key });
          this.filter = filter;
        }
      }
      if(args != undefined)
        params = { args: args, filter: filter, page_size: this.selected_page_size, page_no: 0 }
      else
        params = { filter: filter, page_size: this.selected_page_size, page_no: 0 }
      this.getListData(params, this.resourceDef.resource, this.resourceDef.application, this.resourceDef.query_id);      
    }else if (this.resourceDef.args) {
      if (this['data'].banner.hasOwnProperty('key') && this['data'].banner.key instanceof Object) {
        Object.keys(this.resourceDef.args[0]).forEach((element, index) => {
          this.args += ((index > 0) ? ',' : '') + "" + element + ':' + (this['data'].banner.key[element] ? this['data'].banner.key[element] : this['data'].banner.key[element.toUpperCase()])
        })
        params = { args: this.args, filter: "", page_size: this.selected_page_size, page_no: 0 }
        this.getListData(params, this['data'].resource, this._currentData.currentData.application != undefined ? this._currentData.currentData.application : '', this.resourceDef.query_id);
      }
      else {
        if (this.route.snapshot.queryParams.hasOwnProperty('key')) {
          this.baseService.get(this['data'].banner.datasource.query_id, 'id:' + this.route.snapshot.queryParams.key, this['data'].banner.datasource.resource, this['data'].banner.datasource.application).subscribe(response => {
            console.log(response, 'banner response')
            this['data'].banner.key = response.resource[0]
            Object.keys(this.resourceDef.args[0]).forEach((element, index) => {
              this.args += ((index > 0) ? ',' : '') + element + ':' + (this['data'].banner.key[element] ? this['data'].banner.key[element] : this['data'].banner.key[element.toUpperCase()])
            })
            params = { args: this.args, filter: "", page_size: this.selected_page_size, page_no: 0 }
            this.getListData(params, this.resourceDef.resource, this.resourceDef.application != undefined ? this.resourceDef.application : '', this.resourceDef.query_id);
          })
        }
      }
    }
    else if (this.resourceDef.list != undefined && this.resourceDef.list.PopUpResource != undefined && this.resourceDef.list.PopUpResource && this.resourceDef.list.PopUpResource.args) {
      Object.keys(this.resourceDef.list.PopUpResource.args[0]).forEach((element, index) => {
        this.args += ((index > 0) ? ',' : '') + element + ':' + (this['data'].banner.key[element] ? this['data'].banner.key[element] : this['data'].banner.key[element.toUpperCase()])
      })
      params = { args: this.args, filter: "", page_size: this.selected_page_size, page_no: 0 }
      this.getListData(params, this.resourceDef.resource, '', this.resourceDef.query_id);
    } else if (this['data'] != undefined && this['data'].preDefinedData != undefined && this['data'].preDefinedData) {
      this.newDataList = this['data'].preDefinedData;
      this.loader.hideSpinner();
    }
    else if (this.resourceDef.list != undefined && this.resourceDef.list.APIresource != undefined && this.resourceDef.list.APIresource) {
      this.args = this.baseService.buildDyanamicStr(this.resourceDef.list.APIresource.datasource.args, { data: this['data'].data != undefined ? this['data'].data : this._currentData.existingData });
      if(this.resourceDef.list.APIresource.datasource.filter){
        this.filter = this.baseService.buildDyanamicStr(this.resourceDef.list.APIresource.datasource.filter, { data: this['data'].data != undefined ? this['data'].data : this._currentData.existingData });
      }
      params = { args: this.args, filter: this.filter, page_size: this.selected_page_size, page_no: 0 }
      this.getListData(params, this.resourceDef.list.APIresource.datasource.resource, this.resourceDef.list.APIresource.datasource.application, this.resourceDef.list.APIresource.datasource.query_id);
    }
    else
      this.getListData('', this.resourceDef.resource ? this.resourceDef.resource : (this['data'].resource ? this['data'].resource : ''), this.resourceDef.application ? this.resourceDef.application : (this['data'].application ? this['data'].application : ''), this.resourceDef.query_id);
  }
  getFormData(apiResource, data) {
    let gridData = {
      "query_id": apiResource.query_id
    }
    if (apiResource.args)
      gridData['args'] = this.baseService.buildDyanamicStr(apiResource.args, { data: data });
    if (apiResource.filter)
      gridData['filter'] = this.baseService.buildDyanamicStr(apiResource.filter, { data: data });
    this.baseService.getWithPage(gridData, apiResource.resource, apiResource.application, apiResource.query_id).subscribe(response => {
      if (response.resource && response.resource.length > 0) {
        this._currentData.currentData = response.resource[0];
        this._currentData.dataSet = true;
      } else { }
    });
  }
  initLayoutData() {
    if (this['data'].customButton != undefined) {
      this._currentData.customButton = this['data'].customButton
    } else {
      this._currentData.customButton = {
        "Add": [
          {
            "label": "button.add",
            "icon": "fa fa-plus"
          }
        ],
        "update": [
          {
            "label": "button.update",
            "icon": "fa fa-check"
          }
        ]
      };
    }

    if (this._layout == 'simple') {
      if(this._currentData.resourceDef.form){
        this.getData(this._currentData.resourceDef);
      }else{
        this.baseService.getResourceDef(this._currentData.resourceDef.resource, (resouceDef) => {
          this.getData(resouceDef);
          if (resouceDef && resouceDef.customButton) {
            this._currentData.customButton = resouceDef.customButton;
          } else if (resouceDef && resouceDef.custom_button) {
            this._currentData.customButton = resouceDef.custom_button;
          }
        });
      }
    }
    else {
      if (this._currentData.resourceDef.layout != undefined && this._currentData.resourceDef.layout.length) {
        let allPromiseObj: any = [];
        for (const layout of this._currentData.resourceDef.layout) {
          if (layout.action_name == undefined || this.rolePermissionService.checkAccessPermission(layout.action_name, layout.resource, layout.application)) {
            this._layout_data[layout.id] = {};
            this._layout_data[layout.id]['data'] = layout;
            allPromiseObj.push(this.asyncProcess(layout));
          }
        }
        //Checking if all resource json are loaded.
        Promise.all(allPromiseObj).then(() => {
          this.layoutData();
          console.log("this._layout_data==>", this._layout_data);
        });
      } else {
        alert("ERROR PLEASE FIX");
      }
    }
  }
  asyncProcess(layout) {
    return new Promise<void>((resolve, reject) => {
      this.baseService.getResourceDef(layout.resource, (currentResouceDef) => {
        this._layout_data[layout.id]['resource_def'] = currentResouceDef;
        resolve();
      });
    });
  }
  layoutData() {
    this._currentData.resourceDef.resource = this._layout_data[this._currentData._layout_id]['data']['resource'];
    this._currentData.resourceDef.application = this._layout_data[this._currentData._layout_id]['data']['application'];
    var resouceDef = this._layout_data[this._currentData._layout_id]['resource_def'];
    this.getData(resouceDef);
  }
  activeTab(key) {
    this._currentData._layout_id = key;
    this._currentData.render_template = false;
    setTimeout(() => {
      this._currentData.addButton = undefined;
      this._currentData.render_template = true;
      this._currentData.decorator = '';
      this._currentData.gridData = {};
      this._currentData.APIresource = {};
      this.initLayoutData();
    });
  }
  setConfigForForm(resourceDef) {
    this._currentData.config = {
      "filterForm": false,
      "submitButton": true,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": '',
      "id": resourceDef.config && resourceDef.config.id ? resourceDef.config.id : resourceDef.resource,
      "popup_decorator": resourceDef.config && resourceDef.config.popup_decorator ? resourceDef.config.popup_decorator : false,
      "floating_button": resourceDef.config && resourceDef.config.floating_button ? resourceDef.config.floating_button : false,
      "composite_formType": this['data'] && this['data'].tempType && this['data'].tempType == "pushable" ? "pushable" : "",
      "QrCodeScan": resourceDef && resourceDef.config && resourceDef.config.QrCodeScan ? resourceDef.config.QrCodeScan : false,
      "QrCodeSchema": resourceDef && resourceDef.QrCodeSchema ? resourceDef.QrCodeSchema : {}
    }
  }
  getData(resourceDef) {
    if (resourceDef) {
      this.setConfigForForm(resourceDef);
      if (resourceDef.config && resourceDef.config.decorator != undefined) {
        this._currentData.decorator = this.baseService.initDecorator(resourceDef.config.decorator, this.route, this.injector);
      }
      //console.log("ResourceDef os ", resourceDef);
      this.baseService.getReferredField(resourceDef.form, (response) => {
        //console.log("Response is ", response);

        this._currentData._currentFormFields = {};
        this._currentData._currentFormFields.blocks = [];
        //added for layout_type one-column or three-column....
        if (this['data'].layout_column) {
          response.forEach(element => {
            element['layout_type'] = this['data'].layout_column;
          });
        }
        this._currentData._currentFormFields.blocks = response;
        if (resourceDef.form.id)
          this._currentData._currentFormFields.id = resourceDef.form.id;
        if (resourceDef.form.datasource)
          this._currentData._currentFormFields.datasource = resourceDef.form.datasource;
        if (resourceDef.form.resetForm)
          this._currentData._currentFormFields.resetForm = resourceDef.form.resetForm;
        if (resourceDef.form.hasOwnProperty('submitButton')) {
          this._currentData._currentFormFields.submitButton = resourceDef.form.submitButton;
        } else {
          this._currentData._currentFormFields.submitButton = true;
        }
        if (resourceDef.form.hasOwnProperty('APIresource')) {
          this._currentData._currentFormFields.APIresource = resourceDef.form.APIresource;
        }
        //added only for set pushable formData
        if (this['data'] && this['data'].tempType && this['data'].tempType == "pushable" && this._currentData.currentData && this._currentData.currentData.banner)
          this._currentData._currentFormFields.bannerJson = this._currentData.currentData.banner;
        this._currentData._currentFormFields.loaded = true;
        //this._currentData._currentFormFields.bannerJson = this._currentData.bannerJson;
        //this.loadComponent();
      });
    } else {
      alert('Network Error, please retry');
    }
  }

  buttonAction(menuObj) {
    this._currentData.customClick = true;
    console.log("menuObj ", menuObj);
    if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.action == "print" && menuObj?.$event?.ctrlKey) {
      menuObj.actionType.action = "print-async";
    }
    if (menuObj.actionType.required_rowData) {
      sessionStorage.setItem('currentData', JSON.stringify(menuObj.data))
    }
    switch (menuObj.actionType.action) {
      case "custom":
        this.customRoute(menuObj.actionType, menuObj.data);
        break;
      case "delete":
        this.removeRow(menuObj.index)
        break;
      case "print":
        this.handleFile(menuObj.actionType, menuObj);
      break;
      case "print-async":
        this.handleFile(menuObj.actionType, menuObj);
      break;
      case "copy":
        this.dialogRef.close(menuObj);
      break
      case "remote_confirm":
        if (!menuObj.actionType.key)
          this.confirmRemote(menuObj.data, menuObj.actionType);
        else
          this.confirmRemote(menuObj.data[menuObj.actionType.key], menuObj.actionType);
        break;
      default:
        this.goToRoute(menuObj.actionType, menuObj.data[menuObj.actionType.key], menuObj.data);
        break;
    }
  }

  handleFile(action, obj, callback = null) {
    this.loader.stophideSpinner(true);
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
      fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : this._currentData.resource;
      fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
      fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
      if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this._currentData.bannerJson.key.facility_id);
      } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
      }
      fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
      if (action.action == "print-async") {
        fileObj.action = action.action;
      }
      this.baseService.handleFile(fileObj, async (fileData) => {
        this.loader.stophideSpinner(false);
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              if (response.printErrorMessage && response.printErrorMessage != undefined) {
                response["printErrorMessage"] = this.utilService.extractTextContent(response.printErrorMessage);
              }
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              if (fileObj.action && fileObj.action == "print-async" && response.errCode == 0 && response.message != undefined) {
                this.alerts.success(response.message, "", true);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
          }
        } else {
          this.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
        this.loader.hideSpinner();
      });
    } else {
      this.loader.stophideSpinner(false);
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }

  removeRow(data) {
    this.newDataList['resource'].splice(data, 1);
  }
  customRoute(action, key) {
    if (this.dialogRef)
      this.dialogRef.close();
    //this will work as new capability
    if (action.route_path != undefined && action.route_path) {
      //here key is the data of the row
      this.baseService.redirectToOtherPage(action.route_path, key);
    }
    else {
      //console.log("Key ", action, key);
      var app = '';
      if (action.hasOwnProperty('application')) {
        app = action.application;
      } else {
        app = this.appService.getApplication();
      }
      var keyForUrl = '';
      if (action.hasOwnProperty('get_key')) {
        keyForUrl = this.route.snapshot.queryParams.key;
      } else {
        if (action.set_key != undefined && action.set_key != '') {
          keyForUrl = key[action.set_key];
        } else {
          keyForUrl = key.id ? key.id : key;//change by saurav deep for getting key
        }
      }
      let queryParams = { key: keyForUrl };
      if (action.hasOwnProperty('query_params')) {
        let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
        queryParams = { ...queryParams, ...{ query_params } }
      }
      if (action.hasOwnProperty('queryParams')) {
        let banner = { banner: JSON.stringify(action.queryParams) }
        queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
      } else {
        let returnUrl = { returnUrl: this.router.url };
        queryParams = { ...queryParams, ...returnUrl }
      }
      console.log("query Params is ", queryParams);
      let url = '';
      if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
        if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
          url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else if (action.redirect.action == 'list') {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        }
      } else if (action.hasOwnProperty('redirectLink')) {
        action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
        url = '/' + app + '/' + action.redirectLink;
        if (action.hasOwnProperty('queryParams')) {
          this.router.navigate([url], {
            queryParams: queryParams
          });
        } else {
          this.router.navigate([url], { queryParams: queryParams });
        }
      }
    }
  }

  goToRoute(action, key, data?) {
    if (this.dialogRef)
      this.dialogRef.close();
    var keyForUrl = '';
    if (action.hasOwnProperty('get_key')) {
      keyForUrl = this.route.snapshot.queryParams.key;
    } else {
      keyForUrl = key;
    }
    let route = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
    if (this._currentData.currentForeignId != undefined) {
      if (this.route.snapshot.data.add_foreign != undefined && this.route.snapshot.data.add_foreign) {
        url = '/' + this.appService.getApplication() + '/' + this.route.snapshot.data.resource + '/' + key + '/' + action.action + '/' + this._currentData.currentForeignId;
      } else {
        url = '/' + this.appService.getApplication() + '/' + this.route.snapshot.data.parent_resource + '/' + this._currentData.currentForeignId + '/' + this.route.snapshot.data.resource + '/' + key + '/' + action.action;
      }

    } else {
      var url = '/' + this.appService.getApplication() + '/' + route + '/' + key + '/' + action.action;
    }

    let queryParams = { key: keyForUrl };
    if (action.hasOwnProperty('query_params')) {
      let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: data });
      queryParams = { ...queryParams, ...{ query_params } }
    }
    if (action.hasOwnProperty('queryParams')) {
      let banner = { banner: JSON.stringify(action.queryParams) }
      queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
    } else {
      let returnUrl = { returnUrl: this.router.url };
      queryParams = { ...queryParams, ...returnUrl }
    }
    if (action.hasOwnProperty('queryParams')) {
      this.router.navigate([url], { queryParams: queryParams });
    } else if (action.action == "view_details") {
      url = '/' + this.appService.getApplication() + '/' + this._currentData.resource + '/' + key + '/' + action.resource;
      this.router.navigate([url], { queryParams: queryParams });
    } else {
      this.router.navigate([url], { queryParams: queryParams });
    }
  }

  onSaveFinished(event: any, application?, resource?) {
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.config.popup_decorator) {
      this._currentData.decorator.beforeSubmitRequest(event);
      return;

    }
    if (this._currentData.decorator != undefined && this._currentData.decorator) {
      var submitInsideDecorator = this._currentData.decorator.submitInsideDecorator(event,(result)=>{
        if(result){
          this.smartModalService.sendResult(result);
        }
    });
    if(submitInsideDecorator){
        return;
    }
    }
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this['data'] != undefined && this['data'].getdata != undefined && this['data'].getdata) {
      this.smartModalService.sendResult(event);
      this.dialogRef.close(event);
    } else {
      this.loader.showSpinner();
      delete event.id;
      if (this._currentAction == 'MODIFY') {
        event.result.id = this._currentData.currentData.id;
      } else if (this._currentAction == 'ADD') {
        delete event.result.id;
        delete event.result.g_creation_time;
      }
      var resource: any = '';
      var application: any = '';
      var action = '';
      if (this._currentData && this._currentData._currentFormFields && this._currentData._currentFormFields.APIresource && this._currentData._currentFormFields.APIresource != undefined && this._currentData._currentFormFields.APIresource.datasource != undefined) {
        resource = this._currentData._currentFormFields.APIresource.datasource['resource'];
        application = this._currentData._currentFormFields.APIresource.datasource['application'];
        if (this._currentData._currentFormFields.APIresource.datasource.action != undefined) {
          action = this._currentData._currentFormFields.APIresource.datasource.action;
        } else {
          action = this._currentAction;
        }
      } else {
        resource = this._currentData.resourceDef.resource;
        application = this._currentData.resourceDef.application;
        action = this._currentAction;
      }

      this.baseService.action(event.result, action, application, resource).subscribe(
        // this.baseService.action(event.result, this._currentAction, this._currentData.resourceDef.application, this._currentData.resourceDef.resource).subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.alerts.error(data.message);
          } else {
            if (this._currentAction == 'ADD')
              this.alerts.success("Added Successfully");
            if (this._currentAction == 'MODIFY')
              this.alerts.success("Updated Successfully");
            if (this['action'] == undefined) {
              this.smartModalService.sendResult(data);
              this.dialogRef.close(data);
            } else if (this['action'].popup != undefined && this['action'].popup.existing) {
              let obj = { "resource": [{ ...this._currentData.existingData, ...this._currentData.currentData }] }
              this.smartModalService.sendResult(obj);
              this.dialogRef.close(obj);
            }
            if (this._currentData.decorator != undefined && this._currentData.decorator) {// Need to review this code 
              this._currentData.decorator.afterSubmitReqSuccess(event, data);
            }
            this.formComponenet.resetFormClick();
          }
          this.loader.hideSpinner();
        }, error => {
          console.log(error);
          this.alerts.error('API error');
          this.loader.hideSpinner();
        }
      )
    }

  }
  pageChanged(event) {
    this.loader.showSpinner();
    let params = {
      page_no: event - 1,
      page_size: this.selected_page_size,
      args: this.args,
      filter: (this._currentData['filter'] != undefined ? this._currentData['filter'] : '') + (this._currentData['filter'] != undefined && this._currentData['filter'] != '' && this.filter != undefined && this.filter != '' ? ',' : '') + this.filter
    }
    if (this.filterVal != undefined && this.filterVal) {
      params['search'] = this.filterVal;
    }
    // if (this.resourceDef.list.hasOwnProperty('APIresource')) {
    //   this.getListData(params, this._currentData.APIresource.resource, this._currentData.APIresource.application, this._currentData.APIresource.query_id);
    // } else {
    this.getListData(params, this.resourceDef.resource, this.resourceDef.application, this.resourceDef.query_id);
    // }
  }
  getListData(params, resource, application, query_id) {
    if (params == '') {
      params = {
        page_no: 0,
        page_size: this.selected_page_size,
        // args: 'uhId:'+ (this['data'].banner.key['uhId']?this['data'].banner.key['uhId']:this['data'].banner.key['UHID']),
        // filter: 'uhId:'+ (this['data'].banner.key['uhId']?this['data'].banner.key['uhId']:this['data'].banner.key['UHID'])
      }
    }
    if (this['data'] != undefined && this['data'].config != undefined && this['data'].config.ehr_view_default && (this['data'].config.ehr_view != undefined && this['data'].config.ehr_view || this['data'].config.read_scope_level)) {
      params['read_scope_level'] = "account"
    }
    if (this.resourceDef.list != undefined && this.resourceDef.list.hasOwnProperty('PopUpResource')) {
      this.baseService.getData(params, '', this.resourceDef.list.PopUpResource.resource, this.resourceDef.list.PopUpResource.application, this.resourceDef.list.PopUpResource.query_id).subscribe(gridData => {
        console.log(gridData, 'gridData')
        this.newDataList = gridData;
        this.checkCompositeData();
      })
    } else if (this.resourceDef.list != undefined && this.resourceDef.list.hasOwnProperty('APIresource')) {
      this.baseService.getData(params, '', this.resourceDef.list.APIresource.datasource.resource, this.resourceDef.list.APIresource.datasource.application, this.resourceDef.list.APIresource.datasource.query_id).subscribe(gridData => {
        console.log(gridData, 'gridData')
        this.newDataList = gridData;
        this.checkCompositeData();
        if(gridData?.errCode == -1 && gridData?.message) {
          // 181538
          this.alerts.error(gridData?.message);
        }
      })
    }
    else {
      this.baseService.getData(params, '', resource, application, query_id).subscribe(gridData => {
        console.log(gridData, 'gridData')
        this.newDataList = gridData;
        this.checkCompositeData();
      })
    }
    
    setTimeout(() => {
      this.loader.hideSpinner();
    }, 100)

  }
  checkCompositeData(){
    if(this.resourceDef && this.resourceDef.config && this.resourceDef.config.composite_key && this.newDataList.resource && this.newDataList.resource[0]  && this.newDataList.resource.length>0 && this.newDataList.resource[0].hasOwnProperty(this.resourceDef.config.composite_key)){
      this.newDataList = {resource: this.newDataList.resource[0][this.resourceDef.config.composite_key]};
    }
  }
  onCheckBoxDataEmit(event) {
    if (this['data'] && this['data'].emitAll) {
      this.smartModalService.sendResult(event);
    } else {
      var response: any = [];
      this.resourceDef.list.fields.forEach(element => {
        event.forEach((entity, index) => {
          Object.keys(entity).forEach(data => {
            if ((element.format != undefined && element.format.indexOf(data) != -1) || (data == element.name)) {
              if (response[index] == undefined)
                response.push({});
              response[index][data] = entity[data]
            }
          })
        });
      });
      this.smartModalService.sendResult(response);
    }
    if (this['data'] && this['data'].type == 'pullable' && this['data'].emitAll)
      this.dialogRef.close(event);
    else
      this.dialogRef.close(response);
  }
  limitChanged(event) {
    let params = {
      page_no: 0,
      page_size: event.target.value,
      args: this.args,
      filter: (this._currentData['filter'] != undefined ? this._currentData['filter'] : '') + (this._currentData['filter'] != undefined && this._currentData['filter'] != '' && this.filter != undefined && this.filter != '' ? ',' : '') + this.filter
    }
    this.selected_page_size = event.target.value;
    if (this.filterVal != undefined && typeof this.filterVal == 'object') {
      params['search_columns'] = [this.filterVal.key];
      params['searchColumns'] = this.filterVal.key;
      params['search'] = this.filterVal.value;
      params['searchLabel'] = this.filterVal.label == undefined ? "Search" : this.filterVal.label;

    }
    else if (this.filterVal != undefined) {
      params['search'] = this.filterVal;
    }
    
    this.getListData(params, this.resourceDef.resource, this.resourceDef.application, this.resourceDef.query_id);
  }
  filterChange(event) {
    let params: any = {};
    if (typeof event == 'object') {
      params = {
        page_no: 0,
        page_size: this.selected_page_size,
        args: this.args,
        filter: this._currentData['filter'],
        search_columns: [event.key],
        searchColumns: event.key,
        search: event.value,
        searchLabel: event.label == undefined ? "Search" : event.label,
      }
    } else {
      params = {
        page_no: 0,
        page_size: this.selected_page_size,
        args: this.args,
        filter: (this._currentData['filter'] != undefined ? this._currentData['filter'] : '') + (this._currentData['filter'] != undefined && this._currentData['filter'] != '' && this.filter != undefined && this.filter != '' ? ',' : '') + this.filter,
        search: event
      }
    }
    this.filterVal = event;
    this.getListData(params, this.resourceDef.resource ? this.resourceDef.resource : (this['data'].resource ? this['data'].resource : ''), this.resourceDef.application ? this.resourceDef.application : (this['data'].application ? this['data'].application : ''), this.resourceDef.query_id);
    console.log("popup 262 ", event);
  }
  bindDataToGrid(event) {
    if (event == undefined || event == '' || event == 'ehr_toggle')
      this._currentData['filter'] = '';
    else
      this._currentData['filter'] = event;
    let params = {
      page_no: 0,
      page_size: this.selected_page_size,
      args: this.args,
      filter: (this._currentData['filter'] != undefined ? this._currentData['filter'] : '') + (this._currentData['filter'] != undefined && this._currentData['filter'] != '' && this.filter != undefined && this.filter != '' ? ',' : '') + this.filter
    }
    this.getListData(params, this.resourceDef.resource ? this.resourceDef.resource : (this['data'].resource ? this['data'].resource : ''), this.resourceDef.application ? this.resourceDef.application : (this['data'].application ? this['data'].application : ''), this.resourceDef.query_id);
  }
  emitButtonInfo(btn: any) {
    this.dialogRef.close(btn);
  }

  confirmRemote(menudata, action, type?) {
    if (action.datasource != undefined && action.expression != undefined) {
      var apiObj: any = {};
      var datasource = JSON.parse(JSON.stringify(action.datasource));
      apiObj.resource = datasource.resource != undefined ? datasource.resource : this._currentData.resource;
      apiObj.query_id = datasource.query_id != undefined ? datasource.query_id : 'GET_BY_ID';
      apiObj.application = datasource.application != undefined ? datasource.application : this.appService.getApplication();
      apiObj.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: menudata }) : '';
      apiObj.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: menudata }) : '';
      this.loader.showSpinner();
      this.baseService.getByDataSource(apiObj).subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.alerts.error(data.message);
          } else {
            if (action && action.required_datasource_data)
              sessionStorage.setItem('DatasourceData', JSON.stringify(data.resource[0]));
            if (data.resource != undefined && data.resource.length > 0) {
              var item = data.resource[0];
              console.log(item);
              if (eval(action.expression)) {
                    this.customRoute(action, menudata);
              } else {
                //added condition for dynamic alert
                if (action.msg_key && item[action.msg_key] != undefined && item[action.msg_key] != '') {
                  this.alerts.error(item[action.msg_key]);
                } else {
                  this.alerts.error(action.err_message || 'error');
                }
              }
            } else {
              this.alerts.error(action.err_message || 'error');
            }
          }
          this.loader.hideSpinner();
        }, error => {
          console.log(error);
          this.alerts.error('API error');
          this.loader.hideSpinner();
        }
      )
    } else {
      console.error("please define datasource");
    }

  }
}



